import { getScrollBarWidth, isServer } from '@okee-uikit/react-utils';
import { useRefCallback } from '../callback';
var dataMap = {
  html: {
    lockCount: 0,
    locked: false,
    originStyle: {}
  },
  body: {
    lockCount: 0,
    locked: false,
    originStyle: {}
  }
};
export function useLockScroll() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$enabled = options.enabled,
      enabled = _options$enabled === void 0 ? true : _options$enabled,
      _options$container = options.container,
      container = _options$container === void 0 ? 'body' : _options$container,
      _options$scrollBarWid = options.scrollBarWidth,
      scrollBarWidth = _options$scrollBarWid === void 0 ? 'auto' : _options$scrollBarWid;
  var data = dataMap[container];
  var handleLock = useRefCallback(function () {
    if (isServer() || !enabled) {
      return;
    }

    data.lockCount++;

    if (data.locked) {
      return;
    }

    data.locked = true;
    var element = container === 'body' ? document.body : document.documentElement;
    data.originStyle = {
      overflow: element.style.getPropertyValue('overflow'),
      position: element.style.getPropertyValue('position'),
      width: element.style.getPropertyValue('width')
    };
    var scrollTop = element.scrollTop;
    var barWidth = scrollBarWidth === 'auto' ? getScrollBarWidth() : scrollBarWidth;
    var rewriteStyle = {
      overflow: 'hidden'
    };
    var bodyIsOverflowing = element.clientWidth < window.innerWidth;

    if (bodyIsOverflowing && barWidth) {
      if (['fixed', 'absolute'].indexOf(data.originStyle.position || '') >= 0) {
        rewriteStyle.position = data.originStyle.position;
      } else {
        rewriteStyle.position = 'initial';
      }

      var documentBodyWidth = data.originStyle.width ? getComputedStyle(element).getPropertyValue('width') : '100%';
      rewriteStyle.width = "calc(".concat(documentBodyWidth, " - ").concat(barWidth, "px)");
    }

    Object.assign(element.style, rewriteStyle);
    element.scrollTop = scrollTop;
  });
  var handleUnlock = useRefCallback(function () {
    if (isServer() || !enabled) {
      return;
    }

    data.locked && data.lockCount--;

    if (data.lockCount || !data.locked) {
      return;
    }

    data.locked = false;
    var element = container === 'body' ? document.body : document.documentElement;
    Object.assign(element.style, data.originStyle);
  });
  return {
    lock: handleLock,
    unlock: handleUnlock
  };
}